import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = { isFetchingOrder: true };

const syncReducers = {
  setShop: (state, { payload }) => {
    return { ...state, ...payload, isFetchingOrder: false };
  },
  clearShop: () => {
    return INITIAL_STATE;
  },
};

const shop = createSlice({
  name: "shop",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setShop, clearShop } = shop.actions;

export default shop.reducer;
